const initialState = () => ({
  isOpened: false,
  payload: {
    data: {},
    onSuccessCallback: null
  }
});

const ACTION_KEY = 'CONFIRMATION_MODAL';

const reducer = (state = initialState(), reduxAction) => {
  switch (reduxAction.type) {
    case `${ACTION_KEY}_OPEN`: {
      const { data, onSuccessCallback } = reduxAction.payload;

      return {
        ...state,
        isOpened: true,
        payload: {
          data,
          onSuccessCallback
        }
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
